import {
  CONTACT_ALL, CONTACT_GET, CONTACT_DEL, CONTACT_PUT, CONTACT_POST,
  CONTACT_LOADING, CONTACT_ERROR, CONTACT_RESET,
} from '../types';
import api from '../../../utils/functions/api';

export const contactCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: CONTACT_LOADING });
    const { data } = await api.post(`${process.env.REACT_APP_API_URL}/contact`, payload);
    dispatch({ type: CONTACT_POST, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: CONTACT_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const contactAll = (params = {}) => async (dispatch) => {
  try {
    const { name = '', size = null, page = 1, contactType = '' } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/contact?name=${name}&size=${size}&page=${page}&contactType=${contactType}`,
    );
    if (status === 200) {
      dispatch({ type: CONTACT_ALL, payload: data });
    }
  } catch (error) {
    dispatch({ type: CONTACT_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const contactGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(`${process.env.REACT_APP_API_URL}/contact/${id}`);
    if (status === 200) {
      dispatch({ type: CONTACT_GET, payload: data });
    }
  } catch (error) {
    dispatch({ type: CONTACT_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const contactPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: CONTACT_LOADING });
    const { data } = await api.put(`${process.env.REACT_APP_API_URL}/contact/${id}`, payload);
    dispatch({ type: CONTACT_PUT, payload: data });
  } catch (error) {
    dispatch({ type: CONTACT_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const contactDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: CONTACT_LOADING });
    const { data } = await api.delete(`${process.env.REACT_APP_API_URL}/contact/${id}`);
    dispatch({ type: CONTACT_DEL, payload: data });
  } catch (error) {
    dispatch({ type: CONTACT_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};

export const contactReset = () => async (dispatch) => {
  dispatch({ type: CONTACT_RESET });
};
